module.exports = __webpack_public_path__ + "img/MTCIMFCB.66f58326.png";